import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import reduxUtils from 'util/redux';
import { debounce } from 'lodash';
import classnames from 'classnames';
import t from 'translations';
import localStorage from 'util/misc/local-storage';

import Icon from 'components/icon';
import SlidingDoor from 'components/sliding-door';
import CartCounter from 'components/cart-counter';
import CartProductListProductInfo from 'components/cart-products-list/product-info';

import { COUNTER_CLICK_DEBOUNCE } from 'constants/debounce-delays';

class CartProductsListItem extends PureComponent {
    static propTypes = {
        isOpened: PropTypes.bool.isRequired,
        tabIndex: PropTypes.number.isRequired,
        item: PropTypes.object.isRequired,
        isFetching: PropTypes.bool.isRequired,
        regionActive: PropTypes.object,
        fetchingId: PropTypes.string,
        setProductAmount: PropTypes.func.isRequired,
        setDraggingTutorial: PropTypes.func.isRequired,
        tooltipId: PropTypes.string,
        products: PropTypes.object.isRequired,
    };

    constructor(props) {
        super(props);

        this.state = {
            isOpened: props.isOpened,
            forceClose: false,
            amount: props.item.amount,
        };
    }

    componentDidMount() {
        if (this.state.isOpened) {
            // Disable the dragging tutorial
            localStorage.set('hideDraggingTutorial', 'true');
            this.tutorialTimer = setTimeout(() => {
                this.props.setDraggingTutorial({ hideDraggingTutorial: true });
                this.setState({ isOpened: false });
            }, 3000);
        }
    }

    componentWillReceiveProps(nextProps) {
        const { item: { amount } } = nextProps;

        this.setState({ isOpened: false });

        // Do not update amount if currently fetching from the server
        if (nextProps.isFetching) {
            return;
        }

        this.setState({
            amount,
        });
    }

    componentDidUpdate() {
        // it was removed so we will need to close the sliding door compoinent
        if (!this.props.products[this.props.item.product.id]) {
            this.setState({ forceClose: true });
        }
    }

    componentWillUnmount() {
        clearTimeout(this.tutorialTimer);
    }

    setAmount = (amount) => {
        amount = Number(amount);

        // Abort if there is currently a server request
        if (this.isFetching || this.state.amount === amount) {
            return;
        }

        if (this.props.regionActive) {
            this.setState({
                amount,
            });
        }

        this.sendAmount(amount);
    };

    add = () => {
        this.setAmount(this.state.amount + 1);
    };

    delete = () => {
        // Abort if there is currently a server request
        if (this.isFetching) {
            return;
        }

        this.sendAmount(0);
    };

    remove = () => {
        this.setAmount(this.state.amount - 1);
    };

    sendAmount = debounce(function(amount) {
        const { item: { product }, setProductAmount } = this.props;

        setProductAmount({ product, amount });
    }, COUNTER_CLICK_DEBOUNCE);

    tutorialTimer = null;

    render() {
        const { item, item: { product: { id, name } }, tooltipId, tabIndex } = this.props;
        const { setAmount, add, remove } = this;
        const { forceClose } = this.state;
        const methods = { setAmount, add, remove };

        return (
            <li className={classnames('cart-products-list--item', { 'cart-products-list--item__has-tooltip': id === tooltipId })}>
                <SlidingDoor forceClose={forceClose} className="cart-products-list--draggable-wrapper"
                    isOpened={this.state.isOpened}
                    direction="left" deltaLimit={60}>
                    <div className="cart-products-list--draggable">
                        <CartProductListProductInfo item={item} add={add}/>
                        <CartCounter tabIndex={tabIndex} productName={name} amount={this.state.amount} {...methods} facet={'cart'} id={id}/>
                    </div>
                </SlidingDoor>
                <button
                    tabIndex={tabIndex}
                    aria-label={t('accessibility.label.delete_product')}
                    className="cart-products-list--delete-button" onClick={() => this.delete(item)}>
                    <Icon className="cart-products-list--trash-icon" symbol="trash" size="medium"/>
                </button>
            </li>
        );
    }
}

export default connect(
    reduxUtils.mapStateToProps({
        isFetching: 'cart.isFetching',
        fetchingId: 'cart.fetchingId',
        tooltipId: 'cart.tooltipId',
        regionActive: 'region.active',
        products: 'cart.items',
    }),
    reduxUtils.mapDispatchToProps({
        setProductAmount: 'cart.setProductAmount',
        setDraggingTutorial: 'cart.setDraggingTutorial',
    }),
)(CartProductsListItem);



// WEBPACK FOOTER //
// ./mcart/assets/src/js/app/components/cart-products-list/item/index.js